import Refresh from "@mui/icons-material/Refresh";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DialogPopup } from "../../../components/DialogPopup";
import AlertInfoIcon from "../../../images/icons/AlertInfoIcon.svg";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import PrintIcon from "../../../images/icons/PrintIcon.svg";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import { loadingEPAHoldingQueueDetails } from "../../../Redux/Slice/EPAHoldingQueueDetailsSlice";
import {
  AlertPurple,
  AlertWarn,
  BtnGroupStyle,
  BtnIconStyle,
  DataGridListStyle,
} from "../../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../../uikit/YSButton";
import ConfirmPopup from "../../../components/ConfirmPopup";
import {
  EPAHoldingQueuePrint,
  EPAHoldingReInitiate,
  EPATokenAcceleratorIFrame,
  RemoveEPAHoldingsById,
} from "../../../Apis/AuthApiServices";
import YSSnackBar from "../../../uikit/YSSnackBar";
import NoRecords from "../../../components/NoRecords";
import {
  DrugTextNTooltip,
  EPAStatusDetails,
  TextNTooltip,
} from "../../../components/Content";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { loadingTopRibbon } from "../../../Redux/Slice/TopRibbonSlice";
import { useNavigate } from "react-router";
import { REPORT_BASE_URL } from "../../../Apis/Constants";

export default function EPAHoldingQueueDetails(props: any) {
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const { mxvalue, docId, docName, setShowFlow } = props;
  const navigate = useNavigate();
  const [oaPopup, setOAPopup] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [rowData, setRowData] = useState({});
  const [selectionData, setSelectionData] = useState("");
  const [printActive, setPrintActive] = useState(false);
  const [reportUrl, setReportUrl] = useState("");
  const [deleteEPAHoldingPopup, setDeleteEPAPopup] = useState(false);
  const [printLoad, setPrintLoad] = useState(false);
  const doctorId: any = localStorage.getItem("doctorId");
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [StateData, SetStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("epaIds", selectionData);
      const result = await RemoveEPAHoldingsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        EPAHoldingQueueDetailsPage(page);
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const handleShowEPADeletePopupClick = () => {
    setDeleteEPAPopup(true);
  };
  const handleHideEPADeletePopupClick = () => {
    setDeleteEPAPopup(false);
  };
  const handleShowOAPopupClick = () => {
    setOAPopup(true);
  };
  const handleHideOAPopupClick = () => {
    setOAPopup(false);
  };
  const [EPAStatusPopup, setEPAStatusPopup] = useState(false);
  const handleShowEPAStatusPopupClick = () => {
    setEPAStatusPopup(true);
  };
  const handleHideEPAStatusPopupClick = () => {
    setEPAStatusPopup(false);
  };
  const [AcceleratorData, setAcceleratorData] = useState<any>([]);
  const [iFrameDetails, setIframeDetails] = useState("");
  const getOpenAccelerator = async ({ doctorId, epaHoldingQueueId }: any) => {
    try {
      const params = new URLSearchParams();
      params.append("doctorId", doctorId);
      params.append("epaId", epaHoldingQueueId);
      const result = await EPATokenAcceleratorIFrame(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setAcceleratorData(result?.data?.response);
      } else {
        setAcceleratorData([]);
      }
    } catch (er) {
      setAcceleratorData([]);
    }
  };
  const epaReinitiate = async (rowData: any) => {
    try {
      const bodyData = {
        epaPrescriptionId: rowData?.epaHoldingQueueId,
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: doctorId,
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
        },
      };
      const result = await EPAHoldingReInitiate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        sessionStorage.setItem("patientId", rowData?.patientId);
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify([result?.data?.response[0]?.prescriptionForm])
        );
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        navigate("/newrxpad");
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const columnsEPAHoldingQueueDetails: GridColDef[] = [
    {
      field: "patientName",
      headerName: "Patient",
      width: 150,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "drugName",
      headerName: "Drug",
      width: 180,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: ({ row }) => <DrugTextNTooltip row={row} />,
    },
    {
      field: "pharmacyName",
      headerName: "Pharmacy",
      width: 180,
      cellClassName: "w25",
      headerClassName: "w25",
      renderCell: (params: any) => <TextNTooltip Text={params.value} />,
    },
    {
      field: "epaCreatedDate",
      headerName: "Date",
      width: 110,
      cellClassName: "w20",
      headerClassName: "w20",
    },
    {
      field: "Status",
      headerName: "Status",
      width: 140,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: ({ row }) => (
        <Typography
          component="div"
          color={
            row?.colorCode === "1"
              ? "#6d1899"
              : row?.colorCode === "2"
              ? "#721C24"
              : "primary"
          }
          variant="body2"
          onClick={() => {
            handleShowEPAStatusPopupClick();
            setRowData(row);
          }}
        >
          {row.overallEpaStatus + "-" + row.currentStatus}
        </Typography>
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "w30",
      headerClassName: "w30",
      renderCell: ({ row }) => (
        <>
          <Box style={{ display: "flex", flexDirection: "column", gap: 3 }}>
            <Typography
              component="div"
              color="primary"
              variant="body2"
              onClick={() => {
                getOpenAccelerator(row);
                handleShowOAPopupClick();
              }}
              marginRight={3}
            >
              Open Accelerator{" "}
            </Typography>
            <Typography
              component="div"
              color="primary"
              variant="body2"
              onClick={() => {
                epaReinitiate(row);
              }}
            >
              Re-initiate
            </Typography>
          </Box>
        </>
      ),
    },
  ];
  const EPAHoldingQueueDetailsState = useSelector((state: any) => {
    return { ...state.EPAHoldingQueueDetailsSlice };
  }); //redux data

  const MainDoctor = localStorage.getItem("DoctorName");
  const [rowCountState, setRowCountState] = useState(
    EPAHoldingQueueDetailsState?.Pagination?.totalItems || 0
  );

  const dispatch = useDispatch();
  const EPAHoldingQueueDetailsPage = (nextPage: number) => {
    let paramsData = {
      pageNumber: nextPage,
      pageSize: pageSize,
      prescriptionType: mxvalue,
      doctorId: docId,
    };
    dispatch(loadingEPAHoldingQueueDetails(paramsData));
  };

  useEffect(() => {
    EPAHoldingQueueDetailsPage(page);
  }, [page, mxvalue]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      EPAHoldingQueueDetailsState?.Pagination?.totalItems !== undefined
        ? EPAHoldingQueueDetailsState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [EPAHoldingQueueDetailsState?.Pagination?.totalItems, setRowCountState]);
  const formRef: any = useRef(null);

  useEffect(() => {
    formRef?.current?.submit();
  }, [AcceleratorData]);

  const epaPrint = async (epaId: any) => {
    try {
      setPrintLoad(true);
      const bodyData = {
        epaId: epaId[0],
        function: "holdingQueue",
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: doctorId === docId ? "" : docId,
          selectedClinicId: sessionStorage.getItem("clinicId") ?? "",
        },
      };
      const result = await EPAHoldingQueuePrint(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setReportUrl(result?.data?.response[0]?.reportUrl);
        setPrintActive(true);
        setPrintLoad(false);
      } else {
        setReportUrl("");
        SetStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        setPrintLoad(false);
      }
    } catch (error) {
      setReportUrl("");
      SetStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong",
          variant: "error",
          open: true,
        };
      });
      setPrintLoad(false);
    }
  };

  return (
    <>
      <Grid
        item
        xs={12}
        md={6}
        textAlign={{ xs: "center", md: "right", lg: "right" }}
      >
        <Box
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            columnGap: 10,
            marginRight: 100,
          }}
        >
          <Typography component="span" color="primary" variant="body2">
            Provider
          </Typography>{" "}
          <Typography component="span" variant="body2">
            {docName === "My Own Prescriptions"
              ? MainDoctor?.toUpperCase()
              : docName?.toUpperCase()}
          </Typography>{" "}
          <BtnIconStyle className="refresh">
            <Tooltip title="Refresh">
              <IconButton
                color="primary"
                onClick={() => {
                  EPAHoldingQueueDetailsPage(page);
                }}
              >
                <Refresh />
              </IconButton>
            </Tooltip>{" "}
          </BtnIconStyle>
        </Box>{" "}
      </Grid>
      <Grid item xs={12} marginBottom={1}>
        {printActive ? (
          <>
            <Grid item xs={12}>
              <iframe
                src={`${REPORT_BASE_URL}${reportUrl}`}
                height="500px"
                width="100%"
                title="PrintReport"
              />
            </Grid>
            <Grid item xs={12}>
              <BtnGroupStyle className="right">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setPrintActive(false);
                    setSelectionData("");
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} marginBottom={1}>
              <AlertWarn>
                <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                <Typography component="span" variant="body2">
                  Red color status says that “Decision is required from end user
                  either to Re-initiate or send as it is as denied”.
                </Typography>
              </AlertWarn>
            </Grid>
            <Grid item xs={12} marginBottom={1}>
              <AlertPurple>
                <img src={AlertInfoIcon} alt="Alert" loading="lazy" />
                <Typography component="span" variant="body2">
                  Purple color status says that “Acknowledgement is required via
                  accelerator to complete the process”.
                </Typography>
              </AlertPurple>
            </Grid>{" "}
            <Grid item xs={12}>
              <DataGridListStyle>
                <DataGrid
                  rows={EPAHoldingQueueDetailsState?.Items ?? []}
                  headerHeight={36}
                  sortingOrder={["desc", "asc"]}
                  columns={columnsEPAHoldingQueueDetails}
                  autoHeight
                  rowHeight={40}
                  pageSize={pageSize}
                  disableSelectionOnClick
                  checkboxSelection
                  onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                  paginationMode="server"
                  getRowId={(row) => row.epaHoldingQueueId ?? uuid()}
                  loading={EPAHoldingQueueDetailsState.isLoading}
                  components={{
                    NoRowsOverlay: NoRecords,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={EPAHoldingQueueDetailsState?.error || undefined}
                  rowCount={rowCountState}
                  page={page}
                  rowsPerPageOptions={[pageSize]}
                  onPageChange={(newPage) => {
                    setPage(newPage);
                  }}
                  onSelectionModelChange={(ids: any) => {
                    setSelectionData(ids);
                  }}
                />
              </DataGridListStyle>
            </Grid>{" "}
            <Grid item xs={12} my={2}>
              <BtnGroupStyle className="middle">
                <YSButton
                  className=""
                  children={"Back"}
                  variant={"outlined"}
                  size={"large"}
                  onClick={() => {
                    setShowFlow(false);
                  }}
                />{" "}
                <YSButton
                  children={
                    printLoad ? (
                      <CircularProgress color="inherit" size={28} />
                    ) : (
                      "Print"
                    )
                  }
                  onClick={() => {
                    if (selectionData.length === 1) {
                      epaPrint(selectionData);
                    } else {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "Please select only one EPA Holding to print.",
                          variant: "error",
                          open: true,
                        };
                      });
                    }
                  }}
                  variant={"outlined"}
                  disabled={
                    EPAHoldingQueueDetailsState?.Items?.length > 0
                      ? false
                      : true
                  }
                  size={"large"}
                  startIcon={<img src={PrintIcon} alt="print" loading="lazy" />}
                />{" "}
                <YSButton
                  children={"Delete"}
                  onClick={handleShowEPADeletePopupClick}
                  variant={"outlined"}
                  disabled={
                    EPAHoldingQueueDetailsState?.Items?.length > 0
                      ? false
                      : true
                  }
                  size={"large"}
                  startIcon={
                    <img src={TrashIcon} alt="Delete" loading="lazy" />
                  }
                />
                <YSButton
                  children={"Confirm Prescription"}
                  color="primary"
                  variant="contained"
                  size={"large"}
                  disabled={
                    EPAHoldingQueueDetailsState?.Items?.length > 0
                      ? false
                      : true
                  }
                  onClick={() => {
                    if (selectionData.length >= 1) {
                      navigate(
                        "/epaconfirmpresctions"
                        // , {
                        //   state: {
                        //     rowData: selectionData,
                        //     type: mxvalue,
                        //   },
                        // }
                      );
                      localStorage.setItem(
                        "epaconfirmpresctions-data",
                        JSON.stringify({
                          rowData: selectionData,
                          type: mxvalue,
                        })
                      );
                    } else {
                      SetStateData((prevState: any) => {
                        return {
                          ...prevState,
                          message:
                            "Please select at least one EPA Holding to Confirm Prescription.",
                          variant: "error",
                          open: true,
                        };
                      });
                    }
                  }}
                />{" "}
              </BtnGroupStyle>
            </Grid>
          </>
        )}
      </Grid>{" "}
      <DialogPopup
        windowsize={"lg"}
        show={oaPopup}
        handleShowPopupClick={handleShowOAPopupClick}
        handleHidePopupClick={handleHideOAPopupClick}
        close={true}
      >
        <form
          action={
            iFrameDetails
              ? iFrameDetails
              : AcceleratorData[0]?.actionDetailsForProcess
          }
          method="post"
          ref={formRef}
          target="launchIframe"
          id="iframeFormId"
        >
          <Grid container spacing={0}>
            <input
              type="hidden"
              name="authToken"
              value={AcceleratorData[0]?.authToken}
            />
            <Grid item xs={12} md={4}>
              <YSButton
                children="Launch Work List"
                variant="contained"
                type="submit"
                onClick={() => {
                  setIframeDetails(
                    AcceleratorData[0]?.actionDetailsForWorklist
                  );
                }}
                size="medium"
                className=""
              />
            </Grid>
            <Grid item xs={12} md={4} textAlign="center">
              <YSButton
                children="View Process Details"
                variant="contained"
                type="submit"
                onClick={() => {
                  setIframeDetails(AcceleratorData[0]?.actionDetailsForProcess);
                }}
                size="medium"
                className=""
              />
            </Grid>
          </Grid>
        </form>

        <Grid item xs={12} textAlign="center" marginTop={1} className="btns">
          <iframe
            title="iframe"
            id="iframeFormId"
            name="launchIframe"
            width={1000}
            height={500}
            loading="lazy"
          />
        </Grid>
      </DialogPopup>
      <DialogPopup
        title="EPA Status Details"
        windowsize={"sm"}
        show={EPAStatusPopup}
        handleShowPopupClick={handleShowEPAStatusPopupClick}
        handleHidePopupClick={handleHideEPAStatusPopupClick}
      >
        <EPAStatusDetails rowData={rowData} />
      </DialogPopup>
      <DialogPopup
        windowsize={"sm"}
        show={deleteEPAHoldingPopup}
        handleShowPopupClick={handleShowEPADeletePopupClick}
        handleHidePopupClick={handleHideEPADeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideEPADeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
      <YSSnackBar
        message={StateData.message}
        variant={StateData.variant}
        open={StateData.open}
        handleClose={() => {
          SetStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
